module.exports = __webpack_public_path__ + "media/images/redes_sociales/youtube-9c24f3115a271cc5f41ecb884f771a29.svg";